import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currency',
})
export class CurrencyBRLProxyPipe
  extends CurrencyPipe
  implements PipeTransform
{
  constructor() {
    super('BRL');
  }

  transform(
    value: any,
    currencyCode: string = 'BRL',
    display: 'code' | 'symbol' | 'symbol-narrow' | string | boolean = 'symbol',
    digitsInfo: string = '1.2-2',
    locale: string = 'pt-BR'
  ): any {
    const transform = super.transform(
      value,
      currencyCode,
      display,
      digitsInfo,
      locale
    );

    return transform ? transform.replace('-', '- ') : '';
  }
}
